import { render, staticRenderFns } from "./Increase.vue?vue&type=template&id=0ba97b4c&"
import script from "./Increase.vue?vue&type=script&lang=js&"
export * from "./Increase.vue?vue&type=script&lang=js&"
import style0 from "./Increase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports